var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_c('ul',{class:{'animated': _vm.isAnimate},style:(_vm.getScrollStyle),attrs:{"id":"carouseWrap"}},_vm._l((_vm.currentList),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(_vm.keyName ? item[_vm.keyName]: item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }